import React from "react";
import Heading from "../../../Components/Typography/Heading";

import MessagesCard from "../../../Modules/Messages";

const MessagesPage: React.FC = ({}) => {
  return <MessagesCard />;
};

export default MessagesPage;
